import { ALLOCATIONS, EXPERIMENTS } from '@fiverr-private/listing_experiments';
import { ABTests } from '@fiverr-private/fiverr_context';

interface IsInFacetCounterRemovalExperimentArgs {
    isBusiness: boolean;
    isTouch: boolean;
    abTests: ABTests;
}

export const isInFacetCounterRemovalExperiment = ({
    isBusiness,
    isTouch,
    abTests,
}: IsInFacetCounterRemovalExperimentArgs) =>
    !isTouch && !isBusiness && Number(abTests[EXPERIMENTS.HAWKS_FACET_COUNTER_REMOVAL]) > Number(ALLOCATIONS.CONTROL);
